import type { FC } from 'react';

import { Spinner } from './Spinner';

/** Полноэкранный центрированный спиннер в стиле бренда (для проверки авторизации и т.п.). */
export const PageLoader: FC = () => (
  <div className="flex min-h-dvh w-full flex-col items-center justify-center bg-[#F1F7FA]">
    <Spinner size="lg" />
    <p className="mt-4 text-sm text-[#151515]/60">Загрузка</p>
  </div>
);
